import { Box } from '@coolblue-development/freddy';

const Trigger = ({
  buttonRef,
  next
}: {
  buttonRef: (node?: Element | null | undefined) => void;
  next?: boolean;
}) => (
  <Box
    ref={buttonRef}
    sx={{
      position: 'absolute',
      width: '1px',
      height: '100%',
      top: 0,
      [next ? 'right' : 'left']: 'calc((128rem / 5) - 5px)'
    }}
  />
);

export default Trigger;
